import { CORE_STATUSES, TASK_LIST_COLORS_CODES } from '../constants/constants';
import Moment from 'moment'

export const getTaskStatusClassName = (coreStatusId, userDate, targetDate, startDate) => {
    let classCode = ''; // Default = NO BACKGROUND COLOR

    if (coreStatusId === CORE_STATUSES.NotApplicable || coreStatusId === CORE_STATUSES.Complete) {
        classCode = TASK_LIST_COLORS_CODES.Complete;
    } else if (coreStatusId !== CORE_STATUSES.NotApplicable && coreStatusId !== CORE_STATUSES.Complete && targetDate < userDate) {
        classCode = TASK_LIST_COLORS_CODES.PastDue;
    } else if (coreStatusId === CORE_STATUSES.InProgress && targetDate >= userDate) {
        classCode = TASK_LIST_COLORS_CODES.InProgress;
    } else if (coreStatusId !== CORE_STATUSES.NotApplicable && coreStatusId !== CORE_STATUSES.Complete && coreStatusId !== CORE_STATUSES.InProgress) {
        const dueThisWeekStart = Moment(userDate);
        // This is different than the Dashboard's concept of "Due Soon", which is currently a range of 10 days
        // I have no idea if that's intentional or not, but as this is apparently a unique location where
        // a color is assigned based on the task being due in a rolling window of 1 week from now, I did not
        // bother to define window size (7 days) as a constant to be reused anywhere.
        const dueThisWeekEnd = Moment(userDate).add(7, 'days');
        const targetDateInRange = targetDate >= dueThisWeekStart && targetDate <= dueThisWeekEnd;
        const startDateInRange = startDate && startDate >= dueThisWeekStart && startDate <= dueThisWeekEnd;
        if (targetDateInRange || startDateInRange) {
            classCode = TASK_LIST_COLORS_CODES.DueThisWeek;
        }
    }
    return classCode;
}
